@use "../../sass/variables/grid";

.ux-quote {
  display: block;
  position: relative;
  width: 100%;
  max-width: var(--ux-quote-max-width);
}

.ux-quote__container {
  position: relative;
  color: #fff;
  background-image: var(--ux-quote-background-image);
  padding: 15px;
  padding-left: 35px;
  z-index: 3;
  box-shadow: var(--ux-quote-box-shadow);
  display: flex;
  width: 95%;

  @media only screen and (min-width: grid.$bp-m) {
    padding: 25px 5% 25px 9%;
  }

  @media only screen and (min-width: grid.$bp-l) {
    padding: 30px 10%;
  }

  &-image {
    flex: 0 0 auto;
    object-fit: cover;
    width: var(--ux-quote-image-width);
    height: var(--ux-quote-image-height);
    margin-right: 3%;
  }

  &-text {
    line-height: var(--ux-quote-text-line-height);
    font-size: var(--ux-quote-text-font-size);
    padding-left: 20px;

    @media only screen and (min-width: grid.$bp-m) {
      padding-left: 40px;
    }

    @media only screen and (min-width: grid.$bp-l) {
      padding: 30px 0 30px 55px;
    }

    &::before {
      display: inline-block;
      position: absolute;
      content: "\00bb";
      font-weight: 700;
      font-size: 30px;
      margin-top: -2px;
      margin-left: -22px;

      @media only screen and (min-width: grid.$bp-m) {
        font-size: 50px;
        margin-top: -5px;
        margin-left: -35px;
      }

      @media only screen and (min-width: grid.$bp-l) {
        font-size: 70px;
        margin-left: -55px;
      }
    }
  }
}

.ux-quote__source-container {
  position: relative;
  background-image: var(--ux-quote-source-container-background-image);
  z-index: 1;
  margin-top: -50px;
  padding: 60px 10px 10px 10%;
  left: 8.3333%;
  color: var(--ux-quote-source-container-color);
  font-size: var(--ux-quote-source-container-font-size);

  @media only screen and (min-width: grid.$bp-m) {
    margin-top: -60px;
    padding-top: 80px;
    padding-bottom: 20px;
  }

  @media only screen and (min-width: grid.$bp-l) {
    margin-top: -80px;
    padding-top: 100px;
  }

  &--image {
    padding-left: 25%;
  }
}
